import { createStore } from 'vuex'
import axios from 'axios';

export default createStore({
	state: {
		data: [],
	},
	mutations: {
		SAVE_MEETPUNTEN (state, data) {
			state.data["meetpunten"] = data;
			console.log(state, data);
		}, 

		SAVE_ZWEMPLEKKEN (state, data) {
			state.data["zwemplekken"] = data;
			console.log(state, data);
		}, 
	},
	getters: {
		meetpunten: state => state.data["meetpunten"],
		zwemplekken: state => state.data["zwemplekken"]
	},
	actions: {
		// loadData ({ commit, state }) {
		// 	return new Promise((resolve, reject) => { 
		// 		if(state.articles.length > 0) {
		// 			resolve();
		// 			return;
		// 		}

		// 		axios
		// 			.get(process.env.VUE_APP_API)
		// 			.then(result => {
		// 				commit("SAVE_DATA", result.data);
		// 				resolve();
		// 			})
		// 			.catch(error => {
		// 				reject();
		// 				throw new Error(`API ${error}`);
		// 			});
		// 	})
		// },  

		loadData ({ commit, state }) {
			return new Promise((resolve, reject) => { 
				if(state.data.length > 0) {
					resolve();
					return;
				}

				axios
					.all([
						axios.get(process.env.BASE_URL + "data/zwemplekken.json"),
						axios.get(process.env.BASE_URL + "data/meetpunten.json")
					])
					.then(result => {
						commit("SAVE_ZWEMPLEKKEN", result[0].data);
						commit("SAVE_MEETPUNTEN", result[1].data);
						resolve();
					})
					.catch(error => {
						reject();
						throw new Error(`API ${error}`);
					});
			})
		}
	},
	modules: {

	}
})
